module.exports = __webpack_public_path__ + "img/img-addvisite-index.b027f255.png";